import http from "../../http-common";
/**
 * Author : LeonardoSarrus
 * 18/11/2025
*/

const get = (data) => {
    return http.post("/TagLayout/FilterTagLayout", data);
};

const create = (data) => {
    return http.post("/TagLayout/InsertTagLayout", data);
};

const update = (data) => {
    return http.post("/TagLayout/UpdateTagLayoyt", data);
};

export default {
    get,
    create,
    update
};